import React from 'react';
import { getHost } from "../../helpers/getHost";

const AccessReport = ({ accessData, report }) => {
    const host = getHost();

    const copyToClipboard = () => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(report).catch(err => {
                console.error('Failed to copy: ', err);
            });
        } else {
            console.warn('Clipboard API is not available');
        }
    };

    const getReportLink = (dataType) => {
        const path = accessData['docx'].replace('docx', dataType);

        return `${host}/${path}`;
    };

    return (
        <div className="flex justify-center mt-4">
            <a
                href={getReportLink('pdf')}
                target="_blank"
                className="text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                style={{backgroundColor: '#6EB5D2'}}
            >
                View as PDF
            </a>
            <a
                href={getReportLink('docx')}
                target="_blank"
                className="text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                style={{backgroundColor: '#6EB5D2'}}
            >
                Download DocX
            </a>
        </div>
    );
}

export default AccessReport;
